@if (featuredProducts$ | async; as featuredProducts) {
  @if (featuredProducts.length > 0) {
    <div class="flex justify-center my-20 px-4">
      <div class="container mx-auto">
        <div class="flex flex-col items-center mb-10 text-center">
          <span class="text-[var(--primary)] font-bold text-sm uppercase tracking-widest mb-2">Curated Collection</span>
          <h2 class="text-4xl font-extrabold text-gray-900">
            Featured Merchandise
          </h2>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          @for (product of featuredProducts; track $index) {
            <app-product
              [imageSrc]="product.images[0] || '/placeholder.svg'"
              [title]="product.name"
              [price]="product.price"
              [oldPrice]="product.oldPrice"
              [id]="product.id"
              [product]="product"
            ></app-product>
          }
        </div>
      </div>
    </div>
  }
}
